import * as React from "react";
import Script from "./Script";
import { Button } from "@mui/material";

export type Props = {
	action: string
	siteKey: string
	disabled?: boolean
	onValidate?: (e:React.MouseEvent) => void
	onSubmit: Function
	noDisplay?: boolean
}

type State = {
	ready: boolean
}

export default class ReCaptcha extends React.Component<Props> {
	state = { ready: false }

	componentDidMount() {
		if(typeof grecaptcha !== "undefined") {
			this.setState({ready: true});
		}
	}

	public execute = function (...params:any) {
		if(!this.isReady()) return;

		if(params) {
			window.grecapthcaSubmitCallback = function () {
				this.props.onSubmit(...params);
				this.resetCallback();
			}.bind(this);
		}

		return window.grecaptcha.execute();
	}

	public reset = function () {
		if(!this.isReady()) return;

		this.resetCallback();

		return window.grecaptcha.reset();
	}

	public getResponse = function () {
		if(!this.isReady()) return
		return window.grecaptcha.getResponse();
	}

	private resetCallback = () => {
		window.grecapthcaSubmitCallback = function () {
			this.props.onSubmit();
		}.bind(this);
	}

	public isReady = () => this.state.ready;

	render = () => <>
		<Script src="https://www.google.com/recaptcha/api.js?onload=grecaptchaLoadCallback" async defer callback={() => {
			window.grecaptchaLoadCallback = function () {
				this.setState({ready: true})
			}.bind(this);
			this.resetCallback();
		}}/>
		<div className="g-recaptcha" data-sitekey={this.props.siteKey} data-callback="grecapthcaSubmitCallback" data-size="invisible" />
		{ !this.props.noDisplay && <Button type="submit" id="recaptcha-submit" disabled={!this.state.ready || this.props.disabled} onClick={(e) => this.props.onValidate(e)} variant="contained" color="primary">{this.props.action}</Button> }
	</>
}